import { render } from "./enrollment-modal.vue?vue&type=template&id=2fb18e9e&scoped=true"
import script from "./enrollment-modal.vue?vue&type=script&lang=js"
export * from "./enrollment-modal.vue?vue&type=script&lang=js"

import "./enrollment-modal.vue?vue&type=style&index=0&id=2fb18e9e&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb18e9e"]])

export default __exports__